module.exports = __webpack_public_path__ + "static/media/black-twist-pen-on-notebook-891059.a232cc95.png";